<template>
<div class="chapter">
<div class="inner_page">
<p class="ptnum" id="pt1"><span><span epub:type="pagebreak" id="page_6" title="6"><span epub:type="pagebreak" id="page_7" title="7"><a href="#/xhtml/Contents#pt-1">PART I</a></span></span></span></p>
<p class="pttitle"><span><a href="#/xhtml/Contents#pt-1">Pesticides Are Poisons</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part01.vue?3da7a760